/*
 * Fragment Block
 * Include content on a page as a fragment.
 * https://www.aem.live/developer/block-collection/fragment
 */

import {
  decorateMain,
} from '../../scripts/scripts.js';

import {
  loadSections,
} from '../../scripts/aem.js';

/**
 * Loads a fragment.
 * @param {string} path The path to the fragment
 * @returns {HTMLElement} The root element of the fragment
 */
export async function loadFragment(path) {
  if (path && path.startsWith('/')) {
    // eslint-disable-next-line no-param-reassign
    path = path.replace(/(\.plain)?\.html/, '');
    const resp = await fetch(`${path}.plain.html`);
    if (resp.ok) {
      const main = document.createElement('main');
      main.innerHTML = await resp.text();

      // reset base path for media to fragment base
      const resetAttributeBase = (tag, attr) => {
        main.querySelectorAll(`${tag}[${attr}^="./media_"]`).forEach((elem) => {
          elem[attr] = new URL(elem.getAttribute(attr), new URL(path, window.location)).href;
        });
      };
      resetAttributeBase('img', 'src');
      resetAttributeBase('source', 'srcset');

      decorateMain(main);
      loadSections(main);
      return main;
    }
  }
  return null;
}

export default async function decorate(block) {
  const link = block?.querySelector('a');
  const path = link?.getAttribute('href') ?? block.textContent.trim();
  const fragment = await Promise.resolve(loadFragment(path));
  const fragmentSection = fragment?.querySelector(':scope .section');
  if (fragmentSection) {
    block.classList.add(...fragmentSection.classList);
    block.classList.remove('section');
    block.replaceChildren(...fragmentSection.childNodes);
  }

  // SWS-1515 - focal point implementation
  const images = block.querySelectorAll('img');
  images.forEach((image) => {
    const { title } = image.dataset;
    if (title?.includes('data-focal')) {
      delete image.dataset.title;
      const [x, y] = title.split(':')[1].split(',');
      image.style.objectPosition = `${x}% ${y}%`;
    }
  });
}
